import { render } from "solid-js/web";
import { AskPageApp } from "./AskPageApp";

document.addEventListener("DOMContentLoaded", () => {
	const mount = document.getElementById("ask-page-root") ?? document.body;
	render(() => <AskPageApp />, mount);
});
